import * as React from "react"
import styled from "styled-components"
import { Spacer } from "../spacers"
import { MediaQuery } from "../../../utils/design-helpers"
import ButtonTextSmall from "../typography/ButtonTextSmall"
import { AddIcon } from "../icons/AddIcon"
import { theme } from "../../theme"

interface ButtonProps {
  title: string
  onClick?: () => void
  icon?: boolean
  disabled?: boolean
  secondary?: boolean
}

const ButtonContainer = styled.button<{
  disabled?: boolean
  secondary?: boolean
}>`
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};
  border: ${(props) =>
    `${props.theme.borders.smallWidth} solid ${
      props.secondary ? props.theme.colors.greyDark : props.theme.colors.white
    }`};
  border-radius: ${(props) => props.theme.borders.buttonRadius};
  padding: ${(props) => `${props.theme.spacings.medium}`};
  background-color: ${(props) => (props.secondary ? "white" : props.theme.colors.dark)};
  display: flex;
  align-items: center;
  ${(props) => props.disabled && "opacity: 0.4"};
  height: 40px;
  box-shadow: 0px 1px 3px 1px rgba(119, 119, 119, 0.25);
  color: ${(props) => (props.secondary ? props.theme.colors.greyDark : props.theme.colors.white)};

  :hover {
    background-color: ${(props) =>
      props.disabled ? undefined : props.secondary ? props.theme.colors.greyLight : props.theme.colors.greyDark};
  }

  ${MediaQuery.XS} {
    padding: 8px;
  }
`

const AddDataButtonTextSmall = styled(ButtonTextSmall)<{ secondary?: boolean }>`
  font-weight: 500;
  color: ${(props) => (props.secondary ? props.theme.colors.greyDark : "white")};
  font-family: Karla;
`

const AddDataButton: React.FunctionComponent<ButtonProps> = ({ title, onClick, icon = true, disabled, secondary }) => {
  return (
    <ButtonContainer onClick={disabled ? undefined : onClick} disabled={disabled} secondary={secondary}>
      {icon && <AddIcon color={secondary ? theme.colors.greyDark : theme.colors.white} />}
      {icon && <Spacer spacing={0.25} />}
      <AddDataButtonTextSmall secondary={secondary}>{title}</AddDataButtonTextSmall>
    </ButtonContainer>
  )
}

export default AddDataButton
